import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import "./ArchivioEventi.scss";
import Pagination from "components/pagination/Pagination";
import { ReactComponent as Timer } from "icons/timer-bold.svg";
import Placeholders from "components/placeholders/Placeholders";
import { BsArrowRight as ArrowRight } from "react-icons/bs";
import Filter from "components/filter/Filter";

const isAllDay = (date1, date2) => {
  if (moment(date1).format("LLL") === moment(date2).format("LLL")) return true;
  else return false;
};

const isSameDate = (date1, date2) => {
  if (moment(date1).format("L") === moment(date2).format("L")) return true;
  else return false;
};

const colorEvent = (type) => {
  switch (type) {
    case "EVENTO INTERAMENTE UTILITALIA":
      return {
        color: "#eb640c",
        text: "Evento Utilitalia",
      };
    case "EVENTI ESTERNI DA SEGNALARE":
      return {
        color: "#00447b",
        text: "Utilitalia segnala",
      };
    case "EVENTO PATROCINATO O IN COLLABORAZIONE":
      return {
        color: "#07ca6e",
        text: "Patrocinio Utilitalia",
      };
    default:
      return {
        color: "#888",
        text: "Riservato",
      };
  }
};

const activeYear = moment().year();

const years = [];

for (let i = 2015; i <= activeYear; i++) {
  years.unshift(i);
}

const initialStateFilter = {
  eventi: [],
  from: 1,
  loading: true,
  totalPages: 1,
  startDate: activeYear + "-01-01",
  endDate: null,
  active: {
    year: "",
  },
  years,
};

export default class ArchivioEventi extends Component {
  state = initialStateFilter;

  componentDidMount() {
    this.fetchEventi();
  }

  componentDidUpdate(oldProps, oldState) {
    if (
      this.state.startDate !== oldState.startDate ||
      this.state.from !== oldState.from
    ) {
      this.fetchEventi();
    }
  }

  fetchEventi = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        "https://api.utilitalia.it/AGE/Events/List",
        {
          calendars: ["Calendario interno"],
          types: [
            "EVENTO INTERAMENTE UTILITALIA",
            "GRANDE EVENTO UTILITALIA",
            "EVENTO PATROCINATO O IN COLLABORAZIONE",
            "CONVEGNO CON PATROCINIO UTILITALIA",
          ],
          // showOnlyWithGalleryOrTract: true,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          orderDirection: "desc",
          pageStart: this.state.from,
          pageSize: "20",
        }
      );

      this.setState({
        totalPages: response?.data?.data?.totalPages || 1,
        eventi: response?.data?.data?.appointments || [],
      });
    } catch (err) {
      console.log("Error fetching archivio eventi", err);
    }
    this.setState({ loading: false });
  };

  handleChange = (value, target) => {
    this.setState({
      active: {
        year: value,
      },
      startDate: value + "-01-01",
      endDate: value + "-12-31",
    });
  };

  handleReset = () => {
    this.setState(initialStateFilter);
  };

  handlePageClick = async (data) => {
    let selected = data.selected;
    window.scrollTo(0, 440);
    this.setState({
      from: selected * 20 + 1,
    });
  };

  render() {
    const filters = [
      {
        name: "year",
        text: "Seleziona l'anno",
        values: years,
      },
    ];

    return (
      <div id="archivio-eventi">
        <Helmet>
          <title>Utilitalia - Archivio Eventi</title>
          <meta
            name="description"
            content="In questa sezione trovi tutti gli eventi organizzati da Utilitalia. Visita il sito"
          />
        </Helmet>
        <div className="hero"></div>
        <div className="container pad-mobile">
          <div className="heading">
            <h2 className="general">
              Archivio <span>Eventi</span>
            </h2>
            <Link to="/calendario-eventi">
              <span className="general">Calendario Eventi</span>
              <ArrowRight />
            </Link>
          </div>
          <Filter
            filters={filters}
            change={this.handleChange}
            reset={this.handleReset}
            value={this.state.active}
          />
          <div className="eventi-list">
            {this.state.loading ? (
              <Placeholders number={9} type="evento" />
            ) : (
              this.state.eventi.map((element, i) => (
                <div className="event" key={i}>
                  <div
                    className="heading"
                    style={{ background: colorEvent(element.type).color }}
                  >
                    <span>
                      {moment(element.startDate).format("DD MMM YYYY")}
                    </span>
                    <span>{colorEvent(element.type).text}</span>
                  </div>
                  <div className="body">
                    <div className="top">
                      <p>{element.subject}</p>
                    </div>
                    <div className="bottom">
                      <div className="time">
                        <Timer />{" "}
                        {isSameDate(element.startDate, element.endDate) ? (
                          isAllDay(element.startDate, element.endDate) ? (
                            <span>Tutto il giorno</span>
                          ) : (
                            <span>
                              {moment(element.startDate).format("HH:mm")} -{" "}
                              {moment(element.endDate).format("HH:mm")}
                            </span>
                          )
                        ) : (
                          <span>
                            {moment(element.startDate).format("DD/MM")} -{" "}
                            {moment(element.endDate).format("DD/MM")}
                          </span>
                        )}
                      </div>
                      {/* <Link to={"/evento/" + element.id} className="btn small"> */}
                      <Link to={"/atto/" + element.id} className="btn small">
                        Dettaglio
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          {this.state.totalPages > 1 && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                paddingTop: 32,
              }}
            >
              <Pagination
                totalPages={this.state.totalPages}
                handlePageClick={this.handlePageClick}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
